import { createSelector } from "@reduxjs/toolkit";
import { isEqual, merge } from "lodash";

export const selectSharepoint = (state) => state.sharepoint;

export const selectSharepointEnabled = (state) =>
  selectSharepoint(state).sharepointEnabled;
export const selectIsSharepointAuthenticated = (state) =>
  selectSharepoint(state).sharepointAuthorized;
export const selectSharepointAuthUrl = (state) =>
  selectSharepoint(state).authUrl;
export const selectSharepointRequestSeq = (state) =>
  selectSharepoint(state).requestSeq;
export const selectSharepointAuthRequestSeq = (state) =>
  selectSharepoint(state).authRequestSeq;
export const selectSharepointAccessCheckOwner = (state) =>
  selectSharepoint(state).accessCheckOwner;
export const selectSharepointAccessResults = (state) =>
  selectSharepoint(state).accessResults;
export const selectSharepointRestricted = (state) =>
  selectSharepoint(state).restricted;
export const selectSharepointNextSkipToken = (state) =>
  selectSharepoint(state).nextSkipToken;
export const selectSharepointData = (state) => selectSharepoint(state).data;
export const selectSharepointSearch = (state) => selectSharepoint(state).search;

const selectSettings = (state) => selectSharepoint(state).settings || {};
const selectEdits = (state) => selectSharepoint(state).edits;

export const selectMergedSettings = createSelector(
  [selectSettings, selectEdits],
  (settings, edits) => merge({}, settings, edits)
);

export const selectIsSettingsDirty = createSelector(
  [selectMergedSettings, selectSettings],
  (mergedSettings, baseSettings) => !isEqual(mergedSettings, baseSettings)
);
